var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLiquidClassUnion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1429 0.705882C12.1429 0.316018 11.8231 0 11.4286 0H4.28571C3.89121 0 3.57143 0.316018 3.57143 0.705882C3.57143 1.09575 3.89121 1.41176 4.28571 1.41176H5V5.4705C2.07332 6.60003 0 9.41369 0 12.7059C0 15.3132 1.3004 17.6203 3.29516 19.0285C3.01069 18.1477 2.85714 17.2092 2.85714 16.2353C2.85714 14.8532 3.16637 13.5424 3.72014 12.3669H1.24111C1.39487 9.38728 3.56441 6.93371 6.42857 6.31162V1.41176H9.28571V2.11765H10.7143V1.41176H11.4286C11.8231 1.41176 12.1429 1.09575 12.1429 0.705882Z",
    fill: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4286 4.23529C16.4286 3.84543 16.1088 3.52941 15.7143 3.52941H8.57143C8.17692 3.52941 7.85714 3.84543 7.85714 4.23529C7.85714 4.62516 8.17692 4.94118 8.57143 4.94118H9.28571V8.99991C6.35904 10.1294 4.28571 12.9431 4.28571 16.2353C4.28571 20.5236 7.80348 24 12.1429 24C16.4822 24 20 20.5236 20 16.2353C20 12.9431 17.9267 10.1294 15 8.99991V4.94118H15.7143C16.1088 4.94118 16.4286 4.62516 16.4286 4.23529ZM13.5714 9.84104V4.94118H10.7143V9.84104C7.85012 10.4631 5.68059 12.9167 5.52682 15.8963H18.7589C18.6051 12.9167 16.4356 10.4631 13.5714 9.84104Z",
    fill: "#313131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquidClassUnion);
export default __webpack_public_path__ + "static/media/LiquidClassUnion.d77cde07c35b60d51dedbab8b11e6d60.svg";
export { ForwardRef as ReactComponent };